import { useCallback } from 'react'
import { toast } from '../../services/toastService'

/**
 * useConfirmLocationClick - Finds and triggers the latest sighting marker's popup
 * from the "Confirm Location" action on the entity detail panel.
 * @atomic
 */
export function useConfirmLocationClick({ entities, currentOpenPopupRef, mapRef, markerRefs, onPanelStateChange, t }) {
  return useCallback(() => {
    // Find the latest sighting (entities are sorted by last seen, first one is latest)
    if (!entities || entities.length === 0) {
      toast.info(t('map.noActiveSighting', 'No active sighting to confirm'))
      return
    }

    const latestSighting = entities[0]

    // Close any currently open popup
    if (currentOpenPopupRef?.current) {
      currentOpenPopupRef.current.closePopup()
    }

    // Minimize panel to make room for the popup
    if (onPanelStateChange) {
      onPanelStateChange('minimized')
    }

    // Find the marker by entity ID and trigger it
    const marker = markerRefs.current[latestSighting.id]
    if (marker) {
      // Simulate a click on the marker to trigger its popup
      marker.fire('click')
    } else {
      // Fallback: try to find by coordinates
      if (mapRef?.current) {
        const map = mapRef.current
        map.setView([latestSighting.currentLatitude, latestSighting.currentLongitude], map.getZoom(), {
          animate: true,
          duration: 0.5
        })

        setTimeout(() => {
          toast.info(t('map.clickMarkerToConfirm', 'Click on the marker to confirm the sighting'))
        }, 600)
      }
    }
  }, [entities, currentOpenPopupRef, mapRef, markerRefs, onPanelStateChange, t])
}
